import { Routes, Route } from "react-router-dom";
import OrderPay from './views/OrderPay'
import LinePayConfirm from './views/LinePayConfirm'

const MainRoute = ({

}) => {
    return <>
        <Routes>
            <Route path={'OrderPay/:order_id'} element={<OrderPay />} ></Route>
            <Route path={'Confirm'} element={<LinePayConfirm />} ></Route>
        </Routes>
    </>
}
export default MainRoute